<template>
  <div>
    <main class="about__main">
      <article class="about__article">
        <div class="about__container about__container--featured container">
          <div :class="['about__featured', 'about__featured--'+page.featured_type]"
            v-if="page.featured_image">
            <img :src="mediaPath(page.featured_image)" :class="['about__featured-image', 'about__featured-image--'+page.featured_type]"
             :alt="$store.getters.page.title" :title="$store.getters.page.title"
            />
          </div>
          <h2 v-text="page.title" class="about__title" />
        </div>
        <section :class="sectionClass(section)" v-for="(section, s) in page.sections"
          :key="s">
          <div :class="['about__container', 'about__container--'+section.type, 'container']">
            <div class="about__rich" v-if="section.type==='rich'" v-html="section.text"
            />
            <div class="about__quote" v-if="section.type==='quote'" :style="{backgroundColor:section.color}">
              <div class="about__qoute-text" v-html="section.text" />
            </div>
            <div class="about__images" v-if="section.type==='images'">
              <div v-if="section.images" :class="['about__media', 'about__media--'+(i)]"
                v-for="(image, i) in section.images" :key="'image'+(i)">
                <img :src="mediaPath(image['image'])" :alt="$store.getters.page.title + ' ' + i" :title="$store.getters.page.title + ' ' + i" :class="['about__image', 'about__image--'+(i)]">
              </div>
            </div>
            <div class="about__list" v-if="section.type==='list'">
              <h2 v-if="section.repeater_title" v-text="section.repeater_title"
              />
              <div class="about__list-intro" v-html="section.intro" />
              <ul class="about__list-items">
                <li class="about__list-item" v-for="(item, i) in section.list"
                  v-text="item.item" :key="'item'+i" />
              </ul>
            </div>
            <slider v-if="section.type==='slider'" :slides="section.slides"
            />
            <div class="about__milestone" v-if="section.type==='milestone'">
                    <img :src="mediaPath(section.image)" :alt="section.text" :title="section.text" />
            </div>
            <div class="about__brands brands" v-if="section.type==='brands'">
              <div class="brands__title">
                <h2 v-text="section.repeater_title" />
              </div>
              <div class="brands__grid">
                <div :class="['brands__item', 'brands__item--'+b]" v-for="(brand, b) in section.brands"
                  :key="b">
                  <div :class="['brands__media', 'brands__media--'+b]">
                    <img :class="['brands__image', 'brands__image--'+b]" :src="mediaPath(brand.mediafinder1)" :alt="section.repeater_title  + ' ' + b" :title="section.repeater_title + ' ' + b"
                    />
                    <a :href="brand.link" target="_blank" class="brands__link" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
import page from '@/mixins/page'
import ifDefined from '@/tools/ifDefined'
import Slider from '@/components/Slider'

export default {
  mixins: [page],
  name: 'AboutTemplate',
  components: {
    Slider
  },
  data() {
    return {
      subNavOpen: false,
      slider: {}
    }
  },
  methods: {
    sectionClass(section) {
      return [
        'about__section',
        'about__section--' +
          (ifDefined(section.grey) && section.grey === '1' ? 'grey' : 'white'),
        'about__section--' +
          (ifDefined(section.type) ? section.type : 'default')
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/AboutTemplate.vue